function isEs6Module(val) {
  return typeof val === 'object' && typeof val.default !== 'undefined';
}

function PageModules() {
  this.init();
}

PageModules.prototype.init = function() {
  this.findElements();
  this.createModules();
}

PageModules.prototype.findElements = function() {
  this.elements = document.querySelectorAll('[data-module],[data-module-init]');
}

PageModules.prototype.createModules = function() {
  var modules = [];

  for (var i = 0; i < this.elements.length; i++) {
    var el = this.elements[i];

    if(el.getAttribute('data-module-initialized')) {
      continue;
    }

    var name = el.getAttribute('data-module');
    if (! name) {
      name = el.getAttribute('data-module-init');
    }

    try {
      // Require module script
      var Module = require('modules/'+name);
      if (isEs6Module(Module)) {
        Module = Module.default;
      }
    } catch(e) {
      var Module = false;
    }

    if(Module) {
      // Initialize the module
      modules.push({
        el: el,
        module: new Module(el)
      });

      el.setAttribute('data-module-initialized', true);
    }
  }

  this.modules = modules;
}

module.exports = PageModules;
